import { Component, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { FreeTrialService } from '../../services/free-trial.service';
import { TenantService } from '@app/Services';
import { takeUntil } from 'rxjs/operators';
import { TrialLog } from '@app/Models/trial-log.model';
import { TrialLogType } from '@app/Enums';
import { AsyncPipe } from '@angular/common';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatNoDataRow } from '@angular/material/table';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-trial-logs-table',
    templateUrl: './trial-logs-table.component.html',
    styleUrls: ['./trial-logs-table.component.scss'],
    imports: [MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatNoDataRow, MatIcon, AsyncPipe]
})
export class TrialLogsTableComponent implements OnInit, OnDestroy {
    trialLogs$: BehaviorSubject<TrialLog[]> = new BehaviorSubject<TrialLog[]>([]);
    displayedColumns = ['logType', 'updatedOn', 'updatedBy', 'notes', 'changes'];

    private isDestroyed$ = new Subject<void>();

    constructor(private trialService: FreeTrialService,
        private tenantService: TenantService) { }

    ngOnInit(): void {
        this.trialService.getTrialLogs(this.tenantService.selectedTenant.TenantId).pipe(
            takeUntil(this.isDestroyed$)
        ).subscribe((logs) => {
            this.trialLogs$.next(logs);
        });
    }

    ngOnDestroy(): void {
        this.isDestroyed$.next();
        this.isDestroyed$.complete();
    }

    getLogTypeClass(logType: TrialLogType): string {
        if (!logType) {
            return '';
        }
        switch (logType) {
            case TrialLogType.CancelTrial:
                return 'cancel-trial';
            case TrialLogType.ExtendTrial:
                return 'extend-trial';
            case TrialLogType.PromoteTrial:
                return 'promote-trial';
            case TrialLogType.ReactivateTrial:
                return 'reactivate-trial';
            case TrialLogType.UpdateTrial:
                return 'update-trial';
            default:
                return '';
        }
    }
}
